// extracted by mini-css-extract-plugin
export var contactDetails = "office-block-module--contactDetails--f60d9";
export var officeDetails = "office-block-module--officeDetails--dbb77";
export var wrapper = "office-block-module--wrapper--063a0 container-module--wrapper--c1517";